// Logic
import { writable } from "svelte/store";

import {
	getSUS,
	getVaccination,
	getCases,
	getAllMunicipalities,
} from "./apiNew";

export const rogalandData = writable(undefined);
export const allKommunesData = writable(undefined);
export const msisData = writable(undefined);
export const manuellData = writable(undefined);
export const vaksineData = writable(undefined);
export const susStore = writable(undefined);

// export const innlagteData = writable(undefined);
// export const worldData = writable(undefined);

// export const initallKommuneData = async () => {
// 	allKommunesData.subscribe(async (value) => {
// 		if (value == undefined) {
// 			await getAllMunicipalities().then((r) => {
// 				allKommunesData.set(r);
// 			});
// 		}
// 	});
// };
// rogalandData.subscribe(async (value) => {
//     if(value == undefined) {
//         await rogaland().then(r => {
//             rogalandData.set(r);
//         })
//     }
// });
// manuellData.subscribe(async (value) => {
// 	if (value == undefined) {
// 		await manuell().then((r) => {
// 			manuellData.set(r);
// 		});
// 	}
// });

// innlagteData.subscribe(async (value) => {
// 	if (value == undefined) {
// 		await innlagt().then((r) => {
// 			innlagteData.set(r);
// 		});
// 	}
// });

// worldData.subscribe(async (value) => {
// 	if (value == undefined) {
// 		await world().then((r) => {
// 			worldData.set(r);
// 		});
// 	}
// });

export const initVaksineData = async () => {
	vaksineData.subscribe(async (value) => {
		if (value == undefined) {
			await getVaccination().then((r) => {
				vaksineData.set(r);
			});
		}
	});
};

export const initApiData = async () => {
	msisData.subscribe(async (value) => {
		if (value == undefined) {
			await getCases().then((r) => {
				msisData.set(r);
			});
		}
	});

	susStore.subscribe(async (value) => {
		if (value == undefined) {
			await getSUS().then((r) => {
				susStore.set(r);
			});
		}
	});

	allKommunesData.subscribe(async (value) => {
		if (value == undefined) {
			await getAllMunicipalities().then((r) => {
				allKommunesData.set(r);
			});
		}
	});

	vaksineData.subscribe(async (value) => {
		if (value == undefined) {
			await getVaccination().then((r) => {
				vaksineData.set(r);
			});
		}
	});
};
